import { put, call } from "redux-saga/effects";
import {
  fetchProductGroupsMetrics,
  fetchWarehouseMetrics,
  fetchProductByGroup,
  fetchLagerKodeByFirmId,
} from "../../felles/APICalls_NV02";
import * as actionsNV02 from "../actions/indexNV02";
import * as actionTypes from "../actions/actionTypesNV02";

export function* fetchLavaMetricsSaga(action: any): Generator<any, void, any> {
  try {
    let response;

    try {
      if (action.type === actionTypes.PRODUCT_METRICS_GET) {
        response = yield call(
          fetchProductGroupsMetrics,
          action.payload.companyId,
          action.payload.warehouse
        );
      } else if (action.type === actionTypes.WAREHOUSE_METRICS_GET) {
        response = yield call(
          fetchWarehouseMetrics,
          action.payload.companyId,
          action.payload.warehouse
        );
      } else if (action.type === actionTypes.PRODUCT_BY_GROUP_GET) {
        response = yield call(
          fetchProductByGroup,
          action.payload.companyId,
          action.payload.group,
          action.payload.warehouse
        );
      } else if (action.type === actionTypes.LAGERKODE_GET) {
        const apiResponse = yield call(fetchLagerKodeByFirmId);
        response = apiResponse.data.data;
      }
    } catch (callError) {
      console.error("Saga: Error in API call:", callError);
      throw callError;
    }

    if (response) {
      if (action.type === actionTypes.PRODUCT_METRICS_GET) {
        yield put(actionsNV02.fetchProductMetricsSuccess(response));
      } else if (action.type === actionTypes.WAREHOUSE_METRICS_GET) {
        yield put(actionsNV02.fetchWarehouseMetricsSuccess(response));
      } else if (action.type === actionTypes.PRODUCT_BY_GROUP_GET) {
        yield put(actionsNV02.fetchProductByGroupSuccess(response));
      } else if (action.type === actionTypes.LAGERKODE_GET) {
        yield put(actionsNV02.fetchLagerKodeSuccess(response));
      }
    } else {
      if (action.type === actionTypes.LAGERKODE_GET) {
        yield put(actionsNV02.fetchLagerKodeFailure("No data received"));
      } else if (action.type === actionTypes.WAREHOUSE_METRICS_GET) {
        yield put(actionsNV02.fetchWarehouseMetricsFailure("No data received"));
      } else if (action.type === actionTypes.PRODUCT_BY_GROUP_GET) {
        yield put(actionsNV02.fetchProductByGroupFailure("No data received"));
      } else {
        yield put(actionsNV02.fetchProductMetricsFailure("No data received"));
      }
    }
  } catch (error) {
    console.error("NV02 Saga error:", error);

    if (action.type === actionTypes.LAGERKODE_GET) {
      yield put(actionsNV02.fetchLagerKodeFailure("Error fetching lager kode"));
    } else if (action.type === actionTypes.WAREHOUSE_METRICS_GET) {
      yield put(
        actionsNV02.fetchWarehouseMetricsFailure("Error fetching warehouse metrics")
      );
    } else if (action.type === actionTypes.PRODUCT_BY_GROUP_GET) {
      yield put(
        actionsNV02.fetchProductByGroupFailure("Error fetching product by group")
      );
    } else {
      yield put(
        actionsNV02.fetchProductMetricsFailure("Error fetching product metrics")
      );
    }
  } finally {
    // Component uses its own loading states (isFetchingGroup, isFetchingLagerKode, etc.)
  }
}
